/*  德文包  */
import deLocale from 'element-ui/lib/locale/lang/de'
const dy = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'Cloud-Festplatte',
        'headerlangSelect' : 'Bitte wählen Sie eine Sprache',
        'headerLoginOut' : 'Abmelden',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'Alle Dateien',
        'sideMenuPhoto' : 'Bilder',
        'sideMunsDoc' : 'Dokumentation',
        'sideMenuVideo' : 'Video',
        'sideMenuSeed' : 'Samen',
        'sideMenuMusic' : 'Musik',
        'sideMenuOrther' : 'Andere',
        'sideMenuShareName' : 'Mein Anteil',
        'sideMenuCollectName' : 'Papierkorb',

        /*  用户语言设定 */
        'mainUpload' : 'Hochladen',
        'mainBuildDir' : 'Neuer Ordner',
        'mainDownloadOutline' : 'Offline herunterladen',
        'mainSearch' : 'Datei suchen',
        'mainAllFile' : 'Alle Dateien',
        'mainFile' : 'Datei',
        'mainSize' : 'Größe',
        'mainDate' : 'Datum',
        'mainFileDel' : 'Löschen',
        'mainConfirmDel' : 'Bestätigen Sie, um fortzufahren?',
        'sure' : 'Bestätigen Sie',
        'cancel' : 'Abbrechen',
        'mainReturn' : 'Zurück zu',
        'mainPagePrev' : 'Nächste Seite',
        'mainPageNext' : 'Zurück',
        'mainLoaded' : 'Geladen',
        'mainTotal' : 'Insgesamt',
        'mainUnit' : 'Streifen',
        'dilatation' : 'Erweiterung',
        /*  回收站设定  */
        'mainHeaderTitle' : 'Tipp: Der Papierkorb belegt keinen Speicherplatz.',
        'mainHeaderButton' : 'Papierkorb leeren',
        'collectName' : 'Papierkorb',
        'mainRevertIts' : 'Wiederherstellen',
        'mianDelData' : 'Zeit löschen',

        'confirmClear' : 'Bestätigen, um ausgewählte Dateien zu löschen? (Kann nach dem Löschen nicht wiederhergestellt werden)',
        'confirmClearAll' : 'Möchten Sie den Papierkorb wirklich leeren?',

        /*  其他设定 */
        'messageBoxTitle' : 'Hinweis',
        'messageBoxConfirmRevert' : 'Bestätigen, um die ausgewählte Datei wiederherzustellen?',
        'loading' : 'Laden ...',
        'loaded' : 'Keine Daten',

        'messageMoveTo' : 'Gehe zu',
        'filterNotice' : 'Geben Sie die zu filternden Schlüsselwörter ein',
        'messageLoaded' : 'Heruntergeladen:',
        'messageMovetion' : 'Datei verschieben',

        'messageMissKeyWord' : 'Bitte geben Sie Suchbegriffe ein',
        'messageFolderLayersLimit' : 'Erstellung fehlgeschlagen Die Tiefe der Ordnerhierarchie überschreitet nicht 5 Ebenen',
        'messageSameFolderName' : 'Erstellung fehlgeschlagen Der gleiche Dateiname ist vorhanden',
        'messageEmptyFolderName' : 'Bitte geben Sie einen Ordnernamen ein',
        'messageMoveSame' : 'Kann nicht in denselben Ordner verschoben werden',
        'messageActionError' : 'Operation fehlgeschlagen',
        'messageActionSuccess' : 'Operation erfolgreich',
        'messageServerIsBusy' : 'Server ist beschäftigt',
        'messageUploadOverLimit' : 'Zu viele Dateien ausgewählt (innerhalb von 5)',
        'messageDiskFreeFull' : 'Unzureichender Benutzerplatz',
        'messageUploadTypeError' : 'Dieser Dateityp kann nicht hochgeladen werden',
        'messageUploadMaxSize' : 'Die Upload-Datei ist zu groß (innerhalb von 10 Millionen)',
        'messageUploadSuccess' : 'Erfolgreich hochgeladen',
        'messageUploadFailed' : 'Upload fehlgeschlagen',
        'messageDownloadFailed' : 'Download fehlgeschlagen'
    },
    ...deLocale
};

export default dy;



// WEBPACK FOOTER //
// ./src/i18n/langs/dy.js